

import React from "react";

const LeftArrow = () => {
    const handleScrollPrev = () => {
      const container = document.querySelector('.react-horizontal-scrolling-menu--scroll-container');
      container.scrollBy({ left: -400, behavior: 'smooth' }); 
    };
    return (
      <button
        onClick={handleScrollPrev}
        className="left btn  rounded-circle"
      >
        <i className="bi bi-arrow-left fs-3"></i>
      </button>
    );
  };

  export default LeftArrow;